module.exports = __webpack_public_path__ + "static/media/helloreportLogo.41c7ab5e.png";